export function video_schema(m_video_url, type) {

  let res = /\.mgtv\.com\/s\/(\d+).html/.exec(m_video_url);
  if (res) {
    const video_id = res[1];
    if (type === 'mobile') {
      return `imgotv://player?clipId=0&plId=0&videoId=${video_id}`
    } else if (type === "pad") {
      return `imgotvhd://player?clipId=0&plId=0&videoId=${video_id}`
    } else {
      return m_video_url;
    }
  }

  res = /\.mgtv\.com\/b\/(\d+)\/?$/.exec(m_video_url);
  if (res) {
    const clip_id = res[1]
    if (type === 'mobile') {
      return `imgotv://player?clipId=${clip_id}&plId=0&videoId=0`
    } else if (type === "pad") {
      return `imgotvhd://player?clipId=${clip_id}&plId=0&videoId=0`
    } else {
      return m_video_url;
    }
  }

  res = /\.mgtv\.com\/b\/(\d+)\/(\d+)\.html/.exec(m_video_url);
  if (res) {
    console.log(res)
    const clip_id = res[1]
    const video_id = res[2]

    if (type === 'mobile') {
      return `imgotv://player?clipId=${clip_id}&plId=0&videoId=${video_id}`
    } else if (type === "pad") {
      return `imgotvhd://player?clipId=${clip_id}&plId=0&videoId=${video_id}`
    } else {
      return m_video_url;
    }
  }

  res = /m\.mgtv\.com\/l\/(\d+)\/?$/.exec(m_video_url);
  if (res) {
    const pl_id = res[1] //播单

    if (type === 'mobile') {
      return `imgotv://player?clipId=0&plId=${pl_id}&videoId=0`
    } else if (type === "pad") {
      return `imgotvhd://player?clipId=0&plId=${pl_id}&videoId=0`
    } else {
      return m_video_url;
    }
  }


  res = /\.mgtv\.com\/l\/(\d+)\/(\d+)\.html/.exec(m_video_url);
  if (res) {
    const pl_id = res[1]
    const video_id = res[2]

    if (type === 'mobile') {
      return `imgotv://player?clipId=0&plId=${pl_id}&videoId=${video_id}`
    } else if (type === "pad") {
      return `imgotvhd://player?clipId=0&plId=${pl_id}&videoId=${video_id}`
    } else {
      return m_video_url;
    }
  }
}


export function isVideo(url) {
  return /\.mgtv\.com\/l/.test(url) || /\.mgtv\.com\/b/.test(url)
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/videoSchema.js